import {
  ICategorizationInfo,
  ITreeInfo,
} from "@/components/ui/TreeSelect/Models";
import { ResourceInfo } from "@/services";
import _, { cloneDeep } from "lodash";

export function convertTreeDataToArray(
  data: ITreeInfo[],
  temp?: ICategorizationInfo[]
): ICategorizationInfo[] {
  const tempClone = temp || [];
  data.forEach((item: ITreeInfo) => {
    tempClone.push({
      guid: item.guid,
      name: item.name,
      iconKey: item.iconKey,
      iconColor: item.iconColor,
      isDefault: item.isDefault,
      isFavorite: item.isFavorite,
      parentId: item.parentId,
      iconClosed: item.iconClosed,
      isDisabled: !item.isUsedFloorPlan,
      isUsedFloorPlan: item.isUsedFloorPlan,
    });
    if (item.children?.length) {
      convertTreeDataToArray(item.children, tempClone);
    }
  });
  return tempClone;
}

export const transformToTree = (arr: ICategorizationInfo[], idName: string, parentName: string) => {
  const nodes: any = {};
  const realIds = arr.map((obj: any) => obj[idName]);
  return arr.filter((obj: any) => {
    const id = obj[idName],
      parentId = obj[parentName];

    nodes[id] = _.defaults(obj, nodes[id], { children: [] });
    // nodes[id] = Object.assign(obj, nodes[id], { children: [] });
    parentId && realIds.includes(parentId) && (nodes[parentId] = nodes[parentId] || { children: [] })["children"].push(obj);
    return !parentId || !realIds.includes(parentId);
  });
};

export function sortNodesAndChildren(nodes: ITreeInfo[]): ITreeInfo[] {
  nodes.sort((a: ITreeInfo, b: ITreeInfo) => {
    if (a.name?.toLowerCase() > b.name?.toLowerCase()) {
      return 1;
    } else if (a.name?.toLowerCase() < b.name?.toLowerCase()) {
      return -1;
    } else {
      return 0;
    }
  });
  nodes.forEach((node) => {
    if (node.children?.length) {
      sortNodesAndChildren(node.children);
    }
  });
  return nodes;
}

export function validateEmail(email: string) {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

export function sortRs(data: ResourceInfo[] | null): ResourceInfo[] {
  const dataClone = cloneDeep(data);
  if(dataClone && dataClone.length) {
    dataClone.sort((a: ResourceInfo, b: ResourceInfo) => {
      if (
        a?.displayName?.toLowerCase() >
        b?.displayName?.toLowerCase()
      ) {
        return 1;
      } else if (
        a?.displayName?.toLowerCase() <
        b?.displayName?.toLowerCase()
      ) {
        return -1;
      } else {
        return 0;
      }
    })
  }
  return dataClone || []
}
